var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_002-pain",
    "data-name": "002-pain",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.458 124.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b53030;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-1",
    d: "M87.567,105.816l-5.75,8.629,13.4,8.932-13.4,8.932,5.75,8.629,26.344-17.561Zm0,0",
    transform: "translate(-55.299 -71.52)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-1",
    d: "M229.5,105.816,203.16,123.377,229.5,140.939l5.75-8.629-13.4-8.932,13.4-8.932Zm0,0",
    transform: "translate(-137.314 -71.52)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-1",
    d: "M133.563,223.922a36.607,36.607,0,0,0-24.163,9.093l-3.9,3.42,6.843,7.794,3.9-3.42a26.288,26.288,0,0,1,34.618-.025l3.9,3.42,6.843-7.791-3.9-3.423a36.575,36.575,0,0,0-24.142-9.066Zm0,0",
    transform: "translate(-71.309 -151.347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-1",
    d: "M62.229,0a62.229,62.229,0,1,0,62.229,62.229A62.3,62.3,0,0,0,62.229,0Zm0,114.086a51.857,51.857,0,1,1,51.858-51.857A51.917,51.917,0,0,1,62.229,114.086Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.089e9fcfda6f2fa94f4b8de413c3a822.svg";
export { ForwardRef as ReactComponent };